<template>
  <!-- Admin panel -->
  <div id="panelLayout">
    <!-- logout dialog -->
    <div id="customConfirmationDialog" v-if="isLogoutDialogOpen">
      <div @click="() => (isLogoutDialogOpen = false)" :class="`modal-backdrop ${isLogoutDialogOpen ? '' : 'hidden'}`"></div>
      <div id="popupModal" tabindex="-1">
        <div class="fixed modal-inner z-[150] w-[95.5%] max-w-md max-h-full">
          <div class="relative bg-white rounded-lg modal_inner_dialog">
            <button
              @click="() => (isLogoutDialogOpen = false)"
              type="button"
              class="absolute top-3 right-2.5 text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5 ml-auto inline-flex items-center">
              <svg aria-hidden="true" class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                <path
                  fill-rule="evenodd"
                  d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                  clip-rule="evenodd" />
              </svg>
              <span class="sr-only">Close modal</span>
            </button>
            <div class="p-6 text-center">
              <svg
                aria-hidden="true"
                class="mx-auto mb-4 text-gray-400 w-14 h-14"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
              <h3 class="mb-5 text-lg font-normal text-gray-500">{{ $t('general.logout_question') }}</h3>
              <div class="flex justify-center items-center gap-2">
                <button
                  :disabled="isLoggingout"
                  @click="() => logoutUser()"
                  type="button"
                  :class="`${
                    isLoggingout ? 'disabled' : ''
                  } text-primary bg-white hover:bg-gray-100 hover:text-gray-900 border border-gray-200 focus:ring-4 focus:outline-none font-medium rounded-lg text-sm inline-flex items-center px-5 py-2.5 text-center mr-2`">
                  {{ $t('general.yes') }}
                </button>
                <button
                  :disabled="isLoggingout"
                  @click="() => (isLogoutDialogOpen = false)"
                  type="button"
                  :class="`${
                    isLoggingout ? 'disabled' : ''
                  } text-primary bg-white hover:bg-gray-100 focus:ring-4 focus:outline-none focus:ring-gray-200 rounded-lg border border-gray-200 text-sm font-medium px-5 py-2.5 hover:text-gray-900 focus:z-10`">
                  {{ $t('general.no') }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="w-full h-full">
      <div class="flex flex-no-wrap">
        <!-- End of DASHBOARD -->
        <!-- Start of SIDEBAR -->
        <div id="sidebar-menu" class="z-40 sidebar-opened md:block fixed -right-[300px] md:sticky h-screen grow overflow-y-auto">
          <Sidebar :toggleSidebar="toggleSidebar" :isSidebarOpen="isSidebarOpen" role="admin">
            <!-- dashboard -->
            <li class="w-full" @click="toggleSidebar('mobile')">
              <NuxtLink :title="$t('panel.dashboard')" :to="ROUTESNAMES.admin.dashboard" class="sidebar-list-item w-full m-0 flex gap-2.5 py-3 px-3">
                <span class>
                  <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 24 24">
                    <path
                      fill="currentColor"
                      d="M13 9V3h8v6h-8ZM3 13V3h8v10H3Zm10 8V11h8v10h-8ZM3 21v-6h8v6H3Zm2-10h4V5H5v6Zm10 8h4v-6h-4v6Zm0-12h4V5h-4v2ZM5 19h4v-2H5v2Zm4-8Zm6-4Zm0 6Zm-6 4Z" />
                  </svg>
                </span>
                <span class="hide-if-close">{{ $t('panel.dashboard') }}</span>
              </NuxtLink>
            </li>
            <!-- categories -->
            <li class="w-full" @click="toggleSidebar('mobile')">
              <NuxtLink
                :title="$t('panel.manage_categories')"
                :to="ROUTESNAMES.admin.categories"
                class="sidebar-list-item w-full m-0 flex gap-2.5 py-3 px-3">
                <span class>
                  <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 20 20">
                    <path
                      fill="currentColor"
                      d="M10.505 3.117a1 1 0 0 0-1.011 0l-6.01 3.52a1 1 0 0 0 .003 1.726l6.009 3.502a1 1 0 0 0 1.007 0l6.009-3.502a1 1 0 0 0 .001-1.727l-6.009-3.52ZM3.07 9.65l6.438 3.622a1 1 0 0 0 .98 0l6.438-3.622a1 1 0 0 1-.415 1.26l-6.01 3.502a1 1 0 0 1-1.006 0l-6.01-3.502a1 1 0 0 1-.415-1.26Zm0 2.453l6.438 3.622a1 1 0 0 0 .98 0l6.438-3.622a1 1 0 0 1-.415 1.26l-6.01 3.502a1 1 0 0 1-1.006 0l-6.01-3.502a1 1 0 0 1-.415-1.26Z" />
                  </svg>
                </span>
                <span class="hide-if-close">{{ $t('panel.manage_categories') }}</span>
              </NuxtLink>
            </li>
            <!-- attributes -->
            <li class="w-full" @click="toggleSidebar('mobile')">
              <NuxtLink
                :title="$t('panel.manage_attributes')"
                :to="ROUTESNAMES.admin.attributes"
                class="sidebar-list-item w-full m-0 flex gap-2.5 py-3 px-3">
                <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 24 24">
                  <g fill="currentColor" fill-rule="evenodd" clip-rule="evenodd">
                    <path
                      d="M3 5.75a1 1 0 0 1 1-1c3.335 0 6.5 2.126 6.5 5.25S7.335 15.25 4 15.25a1 1 0 1 1 0-2c2.74 0 4.5-1.68 4.5-3.25S6.74 6.75 4 6.75a1 1 0 0 1-1-1Z" />
                    <path
                      d="M16 5.75a1 1 0 0 0-1-1c-3.335 0-6.5 2.126-6.5 5.25s3.165 5.25 6.5 5.25a1 1 0 1 0 0-2c-2.74 0-4.5-1.68-4.5-3.25s1.76-3.25 4.5-3.25a1 1 0 0 0 1-1Z" />
                    <path d="M16.46 14.778a.75.75 0 0 1-1.053-.133l-1.5-1.936a.75.75 0 0 1 1.186-.918l1.5 1.935a.75.75 0 0 1-.134 1.052Z" />
                    <path
                      d="M14.05 16.785a.75.75 0 0 1-.15-1.05l1.5-2a.75.75 0 1 1 1.2.9l-1.5 2a.75.75 0 0 1-1.05.15Zm2.41-11.563a.75.75 0 0 0-1.053.133l-1.5 1.936a.75.75 0 0 0 1.186.918l1.5-1.935a.75.75 0 0 0-.134-1.052Z" />
                    <path d="M14.05 3.15a.75.75 0 0 0-.15 1.05l1.5 2a.75.75 0 1 0 1.2-.9l-1.5-2a.75.75 0 0 0-1.05-.15Z" />
                  </g>
                </svg>

                <span class="hide-if-close">{{ $t('panel.manage_attributes') }}</span>
              </NuxtLink>
            </li>
            <!-- packages -->
            <li class="w-full" @click="toggleSidebar('mobile')">
              <NuxtLink :title="$t('panel.manage_packages')" :to="ROUTESNAMES.admin.packages" class="sidebar-list-item w-full m-0 flex gap-2.5 py-3 px-3">
                <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 24 24">
                  <g fill="none" fill-rule="evenodd">
                    <path
                      d="M24 0v24H0V0h24ZM12.594 23.258l-.012.002l-.071.035l-.02.004l-.014-.004l-.071-.036c-.01-.003-.019 0-.024.006l-.004.01l-.017.428l.005.02l.01.013l.104.074l.015.004l.012-.004l.104-.074l.012-.016l.004-.017l-.017-.427c-.002-.01-.009-.017-.016-.018Zm.264-.113l-.014.002l-.184.093l-.01.01l-.003.011l.018.43l.005.012l.008.008l.201.092c.012.004.023 0 .029-.008l.004-.014l-.034-.614c-.003-.012-.01-.02-.02-.022Zm-.715.002a.023.023 0 0 0-.027.006l-.006.014l-.034.614c0 .012.007.02.017.024l.015-.002l.201-.093l.01-.008l.003-.011l.018-.43l-.003-.012l-.01-.01l-.184-.092Z" />
                    <path
                      fill="currentColor"
                      d="M2.172 4.44A1 1 0 0 1 3 4h11a1 1 0 0 1 .928.629l.751 1.876l.34-1.701A1 1 0 0 1 17 4h4a1 1 0 0 1 .98 1.196L21 10.1V18a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-7.807L2.072 5.37a1 1 0 0 1 .1-.932ZM6 11v7h9v-7H6Zm11 0v7h2v-7h-2Zm2.18-2l.6-3h-1.96l-.6 3h1.96Zm-4.657 0l-1.2-3H4.477l1.2 3h8.846ZM11 16a1 1 0 0 1 1-1h1a1 1 0 1 1 0 2h-1a1 1 0 0 1-1-1Z" />
                  </g>
                </svg>

                <span class="hide-if-close">{{ $t('panel.manage_packages') }}</span>
              </NuxtLink>
            </li>
            <!-- packages invoices -->
            <li class="w-full" @click="toggleSidebar('mobile')">
              <NuxtLink
                :title="$t('panel.package_invoices')"
                :to="ROUTESNAMES.admin.package_invoices"
                class="sidebar-list-item w-full m-0 flex gap-2.5 py-3 px-3">
                <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 24 24">
                  <path
                    fill="currentColor"
                    d="M13.5 9.75a.75.75 0 0 0-.75-.75h-6a.75.75 0 0 0 0 1.5h6a.75.75 0 0 0 .75-.75Zm-1 3a.75.75 0 0 0-.75-.75h-5a.75.75 0 1 0 0 1.5h5a.75.75 0 0 0 .75-.75Zm.25 2.25a.75.75 0 1 1 0 1.5h-6a.75.75 0 0 1 0-1.5h6Z" />
                  <path
                    fill="currentColor"
                    fill-rule="evenodd"
                    d="M6 21.75h13A2.75 2.75 0 0 0 21.75 19v-5.5a.75.75 0 0 0-.75-.75h-3.25V4.943c0-1.423-1.609-2.251-2.767-1.424l-.175.125a2.26 2.26 0 0 1-2.622-.004a3.77 3.77 0 0 0-4.372 0a2.26 2.26 0 0 1-2.622.004l-.175-.125c-1.158-.827-2.767 0-2.767 1.424V18A3.75 3.75 0 0 0 6 21.75ZM8.686 4.86a2.27 2.27 0 0 1 2.628 0a3.76 3.76 0 0 0 4.366.005l.175-.125a.25.25 0 0 1 .395.203V19c0 .45.108.875.3 1.25H6A2.25 2.25 0 0 1 3.75 18V4.943a.25.25 0 0 1 .395-.203l.175.125a3.76 3.76 0 0 0 4.366-.005ZM17.75 19v-4.75h2.5V19a1.25 1.25 0 0 1-2.5 0Z"
                    clip-rule="evenodd" />
                </svg>

                <span class="hide-if-close">{{ $t('panel.package_invoices') }}</span>
              </NuxtLink>
            </li>
            <!-- stores -->
            <li class="w-full" @click="toggleSidebar('mobile')">
              <NuxtLink :title="$t('panel.manage_stores')" :to="ROUTESNAMES.admin.stores" class="sidebar-list-item w-full m-0 flex gap-2.5 py-3 px-3">
                <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 24 24">
                  <path
                    fill="currentColor"
                    d="M3.5 2.5h17v2h-17v-2Zm-.82 3h18.64l1.18 5.901V13.5H21v8h-2v-8h-5v8H3v-8H1.5v-2.099L2.68 5.5Zm2.32 8v6h7v-6H5Zm15.48-2l-.8-4H4.32l-.8 4h16.96Z" />
                </svg>

                <span class="hide-if-close">{{ $t('panel.manage_stores') }}</span>
              </NuxtLink>
            </li>
            <!-- products -->
            <li class="w-full" @click="toggleSidebar('mobile')">
              <NuxtLink :title="$t('panel.manage_products')" :to="ROUTESNAMES.admin.products" class="sidebar-list-item w-full m-0 flex gap-2.5 py-3 px-3">
                <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 24 24">
                  <path fill="currentColor" d="M20 21H4V10h2v9h12v-9h2v11M3 3h18v6H3V3m6.5 8h5c.28 0 .5.22.5.5V13H9v-1.5c0-.28.22-.5.5-.5M5 5v2h14V5H5Z" />
                </svg>

                <span class="hide-if-close">{{ $t('panel.manage_products') }}</span>
              </NuxtLink>
            </li>
            <!-- exclusive_offers -->
            <li class="w-full" @click="toggleSidebar('mobile')">
                <NuxtLink
                  :title="$t('panel.manage_exclusive_offers')"
                  :to="ROUTESNAMES.admin.exclusive_offers"
                  class="sidebar-list-item w-full m-0 flex gap-2.5 py-3 px-3"
                >
                <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 24 24"><path fill="currentColor" d="M16 14H8a1 1 0 0 0 0 2h8a1 1 0 0 0 0-2Zm0-4h-6a1 1 0 0 0 0 2h6a1 1 0 0 0 0-2Zm4-6h-3V3a1 1 0 0 0-2 0v1h-2V3a1 1 0 0 0-2 0v1H9V3a1 1 0 0 0-2 0v1H4a1 1 0 0 0-1 1v14a3 3 0 0 0 3 3h12a3 3 0 0 0 3-3V5a1 1 0 0 0-1-1Zm-1 15a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V6h2v1a1 1 0 0 0 2 0V6h2v1a1 1 0 0 0 2 0V6h2v1a1 1 0 0 0 2 0V6h2Z"/></svg>
                  
                  <span class="hide-if-close">{{ $t('panel.manage_exclusive_offers') }}</span>
                </NuxtLink>
              </li>
            <!-- manage complaints -->
            <li class="w-full" @click="toggleSidebar('mobile')">
              <NuxtLink
                :title="$t('panel.manage_complaints')"
                :to="ROUTESNAMES.admin.manage_complaints"
                class="sidebar-list-item w-full m-0 flex gap-2.5 py-3 px-3"
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 24 24">
                  <g fill="none" stroke="currentColor" stroke-width="1.5">
                    <rect x="3.5" y="4.5" width="17" height="15" rx="2.5"/>
                    <path d="M7.5 8h.01M12 8h.01M16.5 8h.01"/>
                    <path stroke-linecap="round" d="M8 13h8M8 16h4"/>
                  </g>
                </svg>

                <span class="hide-if-close">{{ $t('panel.manage_complaints') }}</span>
                <span v-if="complaintsCount > 0" class="bg-red-500 text-white rounded-full min-w-[1.5rem] h-6 px-2 flex items-center justify-center text-xs font-medium">
                  {{ complaintsCount > 99 ? '99+' : complaintsCount }}
                </span>
              </NuxtLink>
            </li>
            <!-- manage Warnings -->
            <li class="w-full" @click="toggleSidebar('mobile')">
              <NuxtLink
                :title="$t('panel.manage_warnings')"
                :to="ROUTESNAMES.admin.warnings"
                class="sidebar-list-item w-full m-0 flex gap-2.5 py-3 px-3"
              >
                <!-- Warnings icon -->
                <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 24 24">
                  <path fill="currentColor" d="M1 21h22L12 2 1 21zm13-3h-2v-2h2v2zm0-4h-2v-4h2v4z"/>
                </svg>
                <span class="hide-if-close">{{ $t('panel.manage_warnings') }}</span>
                <span v-if="warningsCount > 0" class="bg-red-500 text-white rounded-full min-w-[1.5rem] h-6 px-2 flex items-center justify-center text-xs font-medium">
                  {{ warningsCount > 99 ? '99+' : warningsCount }}
                </span>
              </NuxtLink>
            </li>
            <!-- governorates -->
            <li class="w-full" @click="toggleSidebar('mobile')">
              <NuxtLink
                :title="$t('panel.manage_governorates')"
                :to="ROUTESNAMES.admin.governorates"
                class="sidebar-list-item w-full m-0 flex gap-2.5 py-3 px-3">
                <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 24 24">
                  <g fill="none" stroke="currentColor" stroke-width="1.5">
                    <path d="M3 22V12c0-1.886 0-2.828.586-3.414C4.172 8 5.114 8 7 8c1.886 0 2.828 0 3.414.586C11 9.172 11 10.114 11 12" />
                    <path d="M17 22v-6c0-1.886 0-2.828-.586-3.414C15.828 12 14.886 12 13 12h-2c-1.886 0-2.828 0-3.414.586C7 13.172 7 14.114 7 16v6" />
                    <path
                      d="M21 22V7.772c0-1.34 0-2.011-.356-2.525c-.356-.514-.984-.75-2.24-1.22c-2.455-.921-3.682-1.381-4.543-.785C13 3.84 13 5.15 13 7.772V12" />
                    <path
                      stroke-linecap="round"
                      d="M4 8V6.5c0-.943 0-1.414.293-1.707C4.586 4.5 5.057 4.5 6 4.5h2c.943 0 1.414 0 1.707.293C10 5.086 10 5.557 10 6.5V8M7 4V2m15 20H2m8-7h4m-4 3h4" />
                  </g>
                </svg>

                <span class="hide-if-close">{{ $t('panel.manage_governorates') }}</span>
              </NuxtLink>
            </li>
            <!-- manage roles -->
            <ItemDropdown :dropDownTitle="$t('general.manage_clients')" mainRoute="/admin/roles" :currentOpendedDropdown="currentOpendedDropdown" :changeCurrentOpendedDropdown="changeCurrentOpendedDropdown">
              <template v-slot:top-icon>
                <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 24 24">
                  <g fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2">
                    <circle cx="18" cy="15" r="3" />
                    <circle cx="9" cy="7" r="4" />
                    <path
                      d="M10 15H6a4 4 0 0 0-4 4v2m19.7-4.6l-.9-.3m-5.6-2.2l-.9-.3m2.3 5.1l.3-.9m2.2-5.6l.3-.9m.2 7.4l-.4-1m-2.4-5.4l-.4-1m-2.1 5.3l1-.4m5.4-2.4l1-.4" />
                  </g>
                </svg>
              </template>
              <li class="w-full sidebar-nested-item" @click="toggleSidebar('mobile')">
                <NuxtLink :title="$t('general.admins')" :to="ROUTESNAMES.admin.admins" class="sidebar-list-item w-full flex items-center gap-2.5 py-3 px-3">
                  <span>
                    <svg class="hide-if-close" xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 15 15">
                      <path
                        fill="currentColor"
                        fill-rule="evenodd"
                        d="M7.5 9.125a1.625 1.625 0 1 0 0-3.25a1.625 1.625 0 0 0 0 3.25Zm0 1a2.625 2.625 0 1 0 0-5.25a2.625 2.625 0 0 0 0 5.25Z"
                        clip-rule="evenodd" />
                    </svg>
                    <svg class="show-if-close" xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 24 24">
                      <path
                        fill="currentColor"
                        d="M12 23C6.443 21.765 2 16.522 2 11V5l10-4l10 4v6c0 5.524-4.443 10.765-10 12ZM4 6v5a10.58 10.58 0 0 0 8 10a10.58 10.58 0 0 0 8-10V6l-8-3Z" />
                      <circle cx="12" cy="8.5" r="2.5" fill="currentColor" />
                      <path fill="currentColor" d="M7 15a5.782 5.782 0 0 0 5 3a5.782 5.782 0 0 0 5-3c-.025-1.896-3.342-3-5-3c-1.667 0-4.975 1.104-5 3Z" />
                    </svg>
                  </span>
                  <span class="hide-if-close item-title">{{ $t('general.admins') }} </span>
                </NuxtLink>
              </li>
              <li class="w-full sidebar-nested-item" @click="toggleSidebar('mobile')">
                <NuxtLink :title="$t('general.role_users')" :to="ROUTESNAMES.admin.users" class="sidebar-list-item w-full flex items-center gap-2.5 py-3 px-3">
                  <span>
                    <svg class="hide-if-close" xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 15 15">
                      <path
                        fill="currentColor"
                        fill-rule="evenodd"
                        d="M7.5 9.125a1.625 1.625 0 1 0 0-3.25a1.625 1.625 0 0 0 0 3.25Zm0 1a2.625 2.625 0 1 0 0-5.25a2.625 2.625 0 0 0 0 5.25Z"
                        clip-rule="evenodd" />
                    </svg>
                    <svg class="show-if-close" xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 24 24">
                      <g fill="none" fill-rule="evenodd" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round">
                        <path
                          d="M8.5 2.5a3 3 0 0 1 3 3v2a3 3 0 1 1-6 0v-2a3 3 0 0 1 3-3zm7 14v-.728c0-3.187-3.686-5.272-7-5.272s-7 2.085-7 5.272v.728a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1z" />
                        <path
                          fill="currentColor"
                          d="M12.52 2.678A3.001 3.001 0 0 1 14.5 5.5v1c0 1.297-.848 2.581-2 3c.674-.919 1.01-2.086 1.01-3.5s-.331-2.523-.99-3.322zM17.5 17.5h1a1 1 0 0 0 1-1v-.728c0-2.17-1.71-3.83-3.847-4.667c0 0 2.847 2.395 1.847 6.395z" />
                      </g>
                    </svg>
                  </span>
                  <span class="hide-if-close item-title"> {{ $t('general.role_users') }}</span>
                </NuxtLink>
              </li>
              <li class="w-full sidebar-nested-item" @click="toggleSidebar('mobile')">
                <NuxtLink
                  :title="$t('general.moderators')"
                  :to="ROUTESNAMES.admin.moderators"
                  class="sidebar-list-item w-full flex items-center gap-2.5 py-3 px-3">
                  <span>
                    <svg class="hide-if-close" xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 15 15">
                      <path
                        fill="currentColor"
                        fill-rule="evenodd"
                        d="M7.5 9.125a1.625 1.625 0 1 0 0-3.25a1.625 1.625 0 0 0 0 3.25Zm0 1a2.625 2.625 0 1 0 0-5.25a2.625 2.625 0 0 0 0 5.25Z"
                        clip-rule="evenodd" />
                    </svg>
                    <svg class="show-if-close" xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 24 24">
                      <g fill="none" fill-rule="evenodd" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round">
                        <path
                          d="M8.5 2.5a3 3 0 0 1 3 3v2a3 3 0 1 1-6 0v-2a3 3 0 0 1 3-3zm7 14v-.728c0-3.187-3.686-5.272-7-5.272s-7 2.085-7 5.272v.728a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1z" />
                        <path
                          fill="currentColor"
                          d="M12.52 2.678A3.001 3.001 0 0 1 14.5 5.5v1c0 1.297-.848 2.581-2 3c.674-.919 1.01-2.086 1.01-3.5s-.331-2.523-.99-3.322zM17.5 17.5h1a1 1 0 0 0 1-1v-.728c0-2.17-1.71-3.83-3.847-4.667c0 0 2.847 2.395 1.847 6.395z" />
                      </g>
                    </svg>
                  </span>
                  <span class="hide-if-close item-title"> {{ $t('general.moderators') }}</span>
                </NuxtLink>
              </li>
              <li class="w-full sidebar-nested-item" @click="toggleSidebar('mobile')">
                <NuxtLink
                  :title="$t('general.resellers')"
                  :to="ROUTESNAMES.admin.resellers"
                  class="sidebar-list-item w-full flex items-center gap-2.5 py-3 px-3">
                  <span>
                    <svg class="hide-if-close" xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 15 15">
                      <path
                        fill="currentColor"
                        fill-rule="evenodd"
                        d="M7.5 9.125a1.625 1.625 0 1 0 0-3.25a1.625 1.625 0 0 0 0 3.25Zm0 1a2.625 2.625 0 1 0 0-5.25a2.625 2.625 0 0 0 0 5.25Z"
                        clip-rule="evenodd" />
                    </svg>
                    <svg class="show-if-close" xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 24 24">
                      <g fill="none" fill-rule="evenodd" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round">
                        <path
                          d="M8.5 2.5a3 3 0 0 1 3 3v2a3 3 0 1 1-6 0v-2a3 3 0 0 1 3-3zm7 14v-.728c0-3.187-3.686-5.272-7-5.272s-7 2.085-7 5.272v.728a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1z" />
                        <path
                          fill="currentColor"
                          d="M12.52 2.678A3.001 3.001 0 0 1 14.5 5.5v1c0 1.297-.848 2.581-2 3c.674-.919 1.01-2.086 1.01-3.5s-.331-2.523-.99-3.322zM17.5 17.5h1a1 1 0 0 0 1-1v-.728c0-2.17-1.71-3.83-3.847-4.667c0 0 2.847 2.395 1.847 6.395z" />
                      </g>
                    </svg>
                  </span>
                  <span class="hide-if-close item-title"> {{ $t('general.resellers') }}</span>
                </NuxtLink>
              </li>
              <li class="w-full sidebar-nested-item" @click="toggleSidebar('mobile')">
                <NuxtLink
                  :title="$t('general.sub_resellers')"
                  :to="ROUTESNAMES.admin.subResellers"
                  class="sidebar-list-item w-full flex items-center gap-2.5 py-3 px-3">
                  <span>
                    <svg class="hide-if-close" xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 15 15">
                      <path
                        fill="currentColor"
                        fill-rule="evenodd"
                        d="M7.5 9.125a1.625 1.625 0 1 0 0-3.25a1.625 1.625 0 0 0 0 3.25Zm0 1a2.625 2.625 0 1 0 0-5.25a2.625 2.625 0 0 0 0 5.25Z"
                        clip-rule="evenodd" />
                    </svg>
                    <svg class="show-if-close" xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 24 24">
                      <g fill="none" fill-rule="evenodd" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round">
                        <path
                          d="M8.5 2.5a3 3 0 0 1 3 3v2a3 3 0 1 1-6 0v-2a3 3 0 0 1 3-3zm7 14v-.728c0-3.187-3.686-5.272-7-5.272s-7 2.085-7 5.272v.728a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1z" />
                        <path
                          fill="currentColor"
                          d="M12.52 2.678A3.001 3.001 0 0 1 14.5 5.5v1c0 1.297-.848 2.581-2 3c.674-.919 1.01-2.086 1.01-3.5s-.331-2.523-.99-3.322zM17.5 17.5h1a1 1 0 0 0 1-1v-.728c0-2.17-1.71-3.83-3.847-4.667c0 0 2.847 2.395 1.847 6.395z" />
                      </g>
                    </svg>
                  </span>
                  <span class="hide-if-close item-title"> {{ $t('general.sub_resellers') }}</span>
                </NuxtLink>
              </li>
            </ItemDropdown>
            <!-- coupons -->
            <li class="w-full" @click="toggleSidebar('mobile')">
              <NuxtLink :title="$t('panel.manage_coupons')" :to="ROUTESNAMES.admin.coupons" class="sidebar-list-item w-full m-0 flex gap-2.5 py-3 px-3">
                <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 24 24">
                  <path
                    fill="currentColor"
                    d="M14.8 8L16 9.2L9.2 16L8 14.8L14.8 8M4 4h16c1.11 0 2 .89 2 2v4a2 2 0 1 0 0 4v4c0 1.11-.89 2-2 2H4a2 2 0 0 1-2-2v-4c1.11 0 2-.89 2-2a2 2 0 0 0-2-2V6a2 2 0 0 1 2-2m0 2v2.54a3.994 3.994 0 0 1 0 6.92V18h16v-2.54a3.994 3.994 0 0 1 0-6.92V6H4m5.5 2c.83 0 1.5.67 1.5 1.5S10.33 11 9.5 11S8 10.33 8 9.5S8.67 8 9.5 8m5 5c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5s-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5Z" />
                </svg>

                <span class="hide-if-close">{{ $t('panel.manage_coupons') }}</span>
              </NuxtLink>
            </li>
            <!-- offers -->
            <li class="w-full" @click="toggleSidebar('mobile')">
              <NuxtLink :title="$t('panel.manage_offers')" :to="ROUTESNAMES.admin.offers" class="sidebar-list-item w-full m-0 flex gap-2.5 py-3 px-3">
                <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 24 24">
                  <path
                    fill="currentColor"
                    d="m21.41 11.58l-9-9C12.05 2.22 11.55 2 11 2H4c-1.1 0-2 .9-2 2v7c0 .55.22 1.05.59 1.42l9 9c.36.36.86.58 1.41.58s1.05-.22 1.41-.59l7-7c.37-.36.59-.86.59-1.41s-.23-1.06-.59-1.42zM13 20.01L4 11V4h7v-.01l9 9l-7 7.02z" />
                  <circle cx="6.5" cy="6.5" r="1.5" fill="currentColor" />
                </svg>

                <span class="hide-if-close">{{ $t('panel.manage_offers') }}</span>
              </NuxtLink>
            </li>
            <!-- orders -->
            <li class="w-full" @click="toggleSidebar('mobile')">
              <NuxtLink :title="$t('panel.manage_orders')" :to="ROUTESNAMES.admin.orders" class="sidebar-list-item w-full m-0 flex gap-2.5 py-3 px-3">
                <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 24 24">
                  <path
                    fill="currentColor"
                    d="M16 14H8a1 1 0 0 0 0 2h8a1 1 0 0 0 0-2Zm0-4h-6a1 1 0 0 0 0 2h6a1 1 0 0 0 0-2Zm4-6h-3V3a1 1 0 0 0-2 0v1h-2V3a1 1 0 0 0-2 0v1H9V3a1 1 0 0 0-2 0v1H4a1 1 0 0 0-1 1v14a3 3 0 0 0 3 3h12a3 3 0 0 0 3-3V5a1 1 0 0 0-1-1Zm-1 15a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V6h2v1a1 1 0 0 0 2 0V6h2v1a1 1 0 0 0 2 0V6h2v1a1 1 0 0 0 2 0V6h2Z" />
                </svg>

                <span class="hide-if-close">{{ $t('panel.manage_orders') }}</span>
              </NuxtLink>
            </li>
            <!-- withdrawal requests -->
            <li class="w-full" @click="toggleSidebar('mobile')">
              <NuxtLink :title="$t('panel.withdrawal_requests')" :to="ROUTESNAMES.admin.withdrawal_requests" class="sidebar-list-item w-full m-0 flex gap-2.5 py-3 px-3">
                <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 24 24">
                  <path
                    fill="currentColor"
                    d="M16 14H8a1 1 0 0 0 0 2h8a1 1 0 0 0 0-2Zm0-4h-6a1 1 0 0 0 0 2h6a1 1 0 0 0 0-2Zm4-6h-3V3a1 1 0 0 0-2 0v1h-2V3a1 1 0 0 0-2 0v1H9V3a1 1 0 0 0-2 0v1H4a1 1 0 0 0-1 1v14a3 3 0 0 0 3 3h12a3 3 0 0 0 3-3V5a1 1 0 0 0-1-1Zm-1 15a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V6h2v1a1 1 0 0 0 2 0V6h2v1a1 1 0 0 0 2 0V6h2v1a1 1 0 0 0 2 0V6h2Z" />
                </svg>

                <span class="hide-if-close">{{ $t('panel.withdrawal_requests') }}</span>
                <span v-if="withdrawalRequestsCount > 0" class="bg-red-500 text-white rounded-full w-5 h-5 flex items-center justify-center text-xs">
                  {{ withdrawalRequestsCount }}
                </span>
              </NuxtLink>
            </li>
            <!-- home offers -->
            <li class="w-full" @click="toggleSidebar('mobile')">
              <NuxtLink :title="$t('panel.home_offers')" :to="ROUTESNAMES.admin.homepageOffers" class="sidebar-list-item w-full m-0 flex gap-2.5 py-3 px-3">
                <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 24 24">
                  <path
                    fill="currentColor"
                    d="M21 13c.6 0 1.1.2 1.4.6c.4.4.6.9.6 1.4l-8 3l-7-2V7h1.9l7.3 2.7c.5.2.8.6.8 1.1c0 .3-.1.6-.3.8c-.2.2-.5.4-.9.4H14l-1.7-.7l-.3.9l2 .8zM2 7h4v11H2z"/>
                </svg>

                <span class="hide-if-close">{{ $t('panel.home_offers') }}</span>
              </NuxtLink>
            </li>
            <!-- manage unarchived requests -->
            <li class="w-full" @click="toggleSidebar('mobile')">
              <NuxtLink :title="$t('panel.manage_unarchived_requests')" :to="ROUTESNAMES.admin.manageUnarchivedRequests" class="sidebar-list-item w-full m-0 flex gap-2.5 py-3 px-3">
                <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 24 24">
                  <path fill="currentColor" d="M21 13c.6 0 1.1.2 1.4.6c.4.4.6.9.6 1.4l-8 3l-7-2V7h1.9l7.3 2.7c.5.2.8.6.8 1.1c0 .3-.1.6-.3.8c-.2.2-.5.4-.9.4H14l-1.7-.7l-.3.9l2 .8zM2 7h4v11H2z"/>
                </svg>
                <span class="hide-if-close">{{ $t('panel.manage_unarchived_requests') }}</span>
                <span v-if="unarchivedRequestsCount > 0" class="bg-red-500 text-white rounded-full w-5 h-5 flex items-center justify-center text-xs">
                  {{ unarchivedRequestsCount }}
                </span>
              </NuxtLink>
            </li>
            <!-- update profile settings -->
            <!-- <li class="w-full" @click="toggleSidebar('mobile')">
              <NuxtLink
                :title="$t('panel.update_profile')"
                :to="ROUTESNAMES.admin.mySettings"
                class="sidebar-list-item w-full m-0 flex gap-2.5 py-3 px-3"
              >
              <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 32 32"><g fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"><path d="M13.905 3.379A.5.5 0 0 1 14.39 3h3.22a.5.5 0 0 1 .485.379l.689 2.757a.515.515 0 0 0 .341.362c.383.126.755.274 1.115.443a.515.515 0 0 0 .449-.003l2.767-1.383a.5.5 0 0 1 .577.093l2.319 2.319a.5.5 0 0 1 .093.577l-1.383 2.767a.515.515 0 0 0-.003.449c.127.271.243.549.346.833c.053.148.17.265.319.315l2.934.978a.5.5 0 0 1 .342.474v3.28a.5.5 0 0 1-.342.474l-2.934.978a.515.515 0 0 0-.32.315a9.937 9.937 0 0 1-.345.833a.515.515 0 0 0 .003.449l1.383 2.767a.5.5 0 0 1-.093.577l-2.319 2.319a.5.5 0 0 1-.577.093l-2.767-1.383a.515.515 0 0 0-.449-.003a9.994 9.994 0 0 1-.833.346a.515.515 0 0 0-.315.319l-.978 2.934a.5.5 0 0 1-.474.342h-3.28a.5.5 0 0 1-.474-.342l-.978-2.934a.515.515 0 0 0-.315-.32a9.95 9.95 0 0 1-1.101-.475a.515.515 0 0 0-.498.014l-2.437 1.463a.5.5 0 0 1-.611-.075l-2.277-2.277a.5.5 0 0 1-.075-.61l1.463-2.438a.515.515 0 0 0 .014-.498a9.938 9.938 0 0 1-.573-1.383a.515.515 0 0 0-.362-.341l-2.757-.69A.5.5 0 0 1 3 17.61v-3.22a.5.5 0 0 1 .379-.485l2.757-.689a.515.515 0 0 0 .362-.341c.157-.478.35-.94.573-1.383a.515.515 0 0 0-.014-.498L5.594 8.557a.5.5 0 0 1 .075-.611l2.277-2.277a.5.5 0 0 1 .61-.075l2.438 1.463c.152.091.34.094.498.014a9.938 9.938 0 0 1 1.382-.573a.515.515 0 0 0 .342-.362l.69-2.757Z"/><path d="M21 16a5 5 0 1 1-10 0a5 5 0 0 1 10 0Z"/></g></svg>
                <span class="hide-if-close">{{ $t('panel.update_profile') }}</span>
              </NuxtLink>
            </li> -->
            <!-- settings -->
            <ItemDropdown :dropDownTitle="$t('general.settings')" mainRoute="/admin/settings" :currentOpendedDropdown="currentOpendedDropdown" :changeCurrentOpendedDropdown="changeCurrentOpendedDropdown">
              <template v-slot:top-icon>
                <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 24 24"><g fill="none" stroke="white" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="1" stroke-width="1.5"><path d="M10.11 3.9a1 1 0 0 1 .995-.9h1.79a1 1 0 0 1 .995.9l.033.333a7.953 7.953 0 0 1 2.209.915l.259-.212a1 1 0 0 1 1.34.067l1.266 1.266a1 1 0 0 1 .067 1.34l-.212.26c.409.676.72 1.419.915 2.208l.332.033a1 1 0 0 1 .901.995v1.79a1 1 0 0 1-.9.995l-.333.033a7.951 7.951 0 0 1-.915 2.209l.212.259a1 1 0 0 1-.067 1.34l-1.266 1.266a1 1 0 0 1-1.34.067l-.26-.212a7.947 7.947 0 0 1-2.208.915l-.033.332a1 1 0 0 1-.995.901h-1.79a1 1 0 0 1-.995-.9l-.033-.333a7.95 7.95 0 0 1-2.209-.915l-.259.212a1 1 0 0 1-1.34-.067L5.003 17.73a1 1 0 0 1-.067-1.34l.212-.26a7.953 7.953 0 0 1-.915-2.208L3.9 13.89a1 1 0 0 1-.9-.995v-1.79a1 1 0 0 1 .9-.995l.333-.033a7.953 7.953 0 0 1 .915-2.209l-.212-.259a1 1 0 0 1 .067-1.34L6.27 5.003a1 1 0 0 1 1.34-.067l.26.212a7.947 7.947 0 0 1 2.208-.915z"/><circle cx="2.5" cy="2.5" r="2.5" transform="matrix(1 0 0 -1 9.5 14.5)"/></g></svg>
              </template>
              <!-- manage website -->
              <li class="w-full sidebar-nested-item" @click="toggleSidebar('mobile')">
                <NuxtLink
                  :title="$t('panel.manage_website')"
                  :to="ROUTESNAMES.admin.manageWebsite"
                  class="sidebar-list-item w-full flex items-center gap-2.5 py-3 px-3">
                  <span>
                    <svg class="hide-if-close" xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 15 15">
                      <path
                        fill="currentColor"
                        fill-rule="evenodd"
                        d="M7.5 9.125a1.625 1.625 0 1 0 0-3.25a1.625 1.625 0 0 0 0 3.25Zm0 1a2.625 2.625 0 1 0 0-5.25a2.625 2.625 0 0 0 0 5.25Z"
                        clip-rule="evenodd" />
                    </svg>
                    <svg class="show-if-close" xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 24 24">
                      <g fill="none" fill-rule="evenodd" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round">
                        <path
                          d="M8.5 2.5a3 3 0 0 1 3 3v2a3 3 0 1 1-6 0v-2a3 3 0 0 1 3-3zm7 14v-.728c0-3.187-3.686-5.272-7-5.272s-7 2.085-7 5.272v.728a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1z" />
                        <path
                          fill="currentColor"
                          d="M12.52 2.678A3.001 3.001 0 0 1 14.5 5.5v1c0 1.297-.848 2.581-2 3c.674-.919 1.01-2.086 1.01-3.5s-.331-2.523-.99-3.322zM17.5 17.5h1a1 1 0 0 0 1-1v-.728c0-2.17-1.71-3.83-3.847-4.667c0 0 2.847 2.395 1.847 6.395z" />
                      </g>
                    </svg>
                  </span>
                  <span class="hide-if-close">{{ $t('panel.manage_website') }}</span>
                </NuxtLink>
              </li>
                  <!-- manage points -->
                  <li class="w-full sidebar-nested-item" @click="toggleSidebar('mobile')">
                <NuxtLink
                  :title="$t('panel.manage_poins')"
                  :to="ROUTESNAMES.admin.managePoints"
                  class="sidebar-list-item w-full flex items-center gap-2.5 py-3 px-3">
                  <span>
                    <svg class="hide-if-close" xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 15 15">
                      <path
                        fill="currentColor"
                        fill-rule="evenodd"
                        d="M7.5 9.125a1.625 1.625 0 1 0 0-3.25a1.625 1.625 0 0 0 0 3.25Zm0 1a2.625 2.625 0 1 0 0-5.25a2.625 2.625 0 0 0 0 5.25Z"
                        clip-rule="evenodd" />
                    </svg>
                    <svg class="show-if-close" xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 24 24">
                      <g fill="none" fill-rule="evenodd" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round">
                        <path
                          d="M8.5 2.5a3 3 0 0 1 3 3v2a3 3 0 1 1-6 0v-2a3 3 0 0 1 3-3zm7 14v-.728c0-3.187-3.686-5.272-7-5.272s-7 2.085-7 5.272v.728a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1z" />
                        <path
                          fill="currentColor"
                          d="M12.52 2.678A3.001 3.001 0 0 1 14.5 5.5v1c0 1.297-.848 2.581-2 3c.674-.919 1.01-2.086 1.01-3.5s-.331-2.523-.99-3.322zM17.5 17.5h1a1 1 0 0 0 1-1v-.728c0-2.17-1.71-3.83-3.847-4.667c0 0 2.847 2.395 1.847 6.395z" />
                      </g>
                    </svg>
                  </span>
                  <span class="hide-if-close">{{ $t('panel.manage_poins') }}</span>
                </NuxtLink>
              </li>
              <!-- manage ads -->
              <li class="w-full sidebar-nested-item" @click="toggleSidebar('mobile')">
                <NuxtLink
                  :title="$t('panel.manage_ads')"
                  :to="ROUTESNAMES.admin.manageAds"
                  class="sidebar-list-item w-full flex items-center gap-2.5 py-3 px-3">
                  <span>
                    <svg class="hide-if-close" xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 15 15">
                      <path
                        fill="currentColor"
                        fill-rule="evenodd"
                        d="M7.5 9.125a1.625 1.625 0 1 0 0-3.25a1.625 1.625 0 0 0 0 3.25Zm0 1a2.625 2.625 0 1 0 0-5.25a2.625 2.625 0 0 0 0 5.25Z"
                        clip-rule="evenodd" />
                    </svg>
                    <svg class="show-if-close" xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 24 24">
                      <g fill="none" fill-rule="evenodd" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round">
                        <path
                          d="M8.5 2.5a3 3 0 0 1 3 3v2a3 3 0 1 1-6 0v-2a3 3 0 0 1 3-3zm7 14v-.728c0-3.187-3.686-5.272-7-5.272s-7 2.085-7 5.272v.728a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1z" />
                        <path
                          fill="currentColor"
                          d="M12.52 2.678A3.001 3.001 0 0 1 14.5 5.5v1c0 1.297-.848 2.581-2 3c.674-.919 1.01-2.086 1.01-3.5s-.331-2.523-.99-3.322zM17.5 17.5h1a1 1 0 0 0 1-1v-.728c0-2.17-1.71-3.83-3.847-4.667c0 0 2.847 2.395 1.847 6.395z" />
                      </g>
                    </svg>
                  </span>
                  <span class="hide-if-close">{{ $t('panel.manage_ads') }}</span>
                </NuxtLink>
              </li>
              <!-- manage seo -->
              <li class="w-full sidebar-nested-item" @click="toggleSidebar('mobile')">
                <NuxtLink
                  :title="$t('panel.manage_seo')"
                  :to="ROUTESNAMES.admin.manageSEO"
                  class="sidebar-list-item w-full flex items-center gap-2.5 py-3 px-3">
                  <span>
                    <svg class="hide-if-close" xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 15 15">
                      <path
                        fill="currentColor"
                        fill-rule="evenodd"
                        d="M7.5 9.125a1.625 1.625 0 1 0 0-3.25a1.625 1.625 0 0 0 0 3.25Zm0 1a2.625 2.625 0 1 0 0-5.25a2.625 2.625 0 0 0 0 5.25Z"
                        clip-rule="evenodd" />
                    </svg>
                    <svg class="show-if-close" xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 24 24">
                      <g fill="none" fill-rule="evenodd" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round">
                        <path
                          d="M8.5 2.5a3 3 0 0 1 3 3v2a3 3 0 1 1-6 0v-2a3 3 0 0 1 3-3zm7 14v-.728c0-3.187-3.686-5.272-7-5.272s-7 2.085-7 5.272v.728a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1z" />
                        <path
                          fill="currentColor"
                          d="M12.52 2.678A3.001 3.001 0 0 1 14.5 5.5v1c0 1.297-.848 2.581-2 3c.674-.919 1.01-2.086 1.01-3.5s-.331-2.523-.99-3.322zM17.5 17.5h1a1 1 0 0 0 1-1v-.728c0-2.17-1.71-3.83-3.847-4.667c0 0 2.847 2.395 1.847 6.395z" />
                      </g>
                    </svg>
                  </span>
                  <span class="hide-if-close">{{ $t('panel.manage_seo') }}</span>
                </NuxtLink>
              </li>
              <!-- manage notifications -->
              <li class="w-full sidebar-nested-item" @click="toggleSidebar('mobile')">
                <NuxtLink
                  :title="$t('panel.manage_notifications')"
                  :to="ROUTESNAMES.admin.manageNotifications"
                  class="sidebar-list-item w-full flex items-center gap-2.5 py-3 px-3">
                  <span>
                    <svg class="hide-if-close" xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 15 15">
                      <path
                        fill="currentColor"
                        fill-rule="evenodd"
                        d="M7.5 9.125a1.625 1.625 0 1 0 0-3.25a1.625 1.625 0 0 0 0 3.25Zm0 1a2.625 2.625 0 1 0 0-5.25a2.625 2.625 0 0 0 0 5.25Z"
                        clip-rule="evenodd" />
                    </svg>
                    <svg class="show-if-close" xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 24 24">
                      <g fill="none" fill-rule="evenodd" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round">
                        <path
                          d="M8.5 2.5a3 3 0 0 1 3 3v2a3 3 0 1 1-6 0v-2a3 3 0 0 1 3-3zm7 14v-.728c0-3.187-3.686-5.272-7-5.272s-7 2.085-7 5.272v.728a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1z" />
                        <path
                          fill="currentColor"
                          d="M12.52 2.678A3.001 3.001 0 0 1 14.5 5.5v1c0 1.297-.848 2.581-2 3c.674-.919 1.01-2.086 1.01-3.5s-.331-2.523-.99-3.322zM17.5 17.5h1a1 1 0 0 0 1-1v-.728c0-2.17-1.71-3.83-3.847-4.667c0 0 2.847 2.395 1.847 6.395z" />
                      </g>
                    </svg>
                  </span>
                  <span class="hide-if-close">{{ $t('panel.manage_notifications') }}</span>
                </NuxtLink>
              </li>
              <!-- wizard helpers -->
              <li class="w-full sidebar-nested-item" @click="toggleSidebar('mobile')">
                <NuxtLink
                  :title="$t('panel.wizard')"
                  :to="ROUTESNAMES.admin.wizardHelpers"
                  class="sidebar-list-item w-full flex items-center gap-2.5 py-3 px-3">
                  <span>
                    <svg class="hide-if-close" xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 15 15">
                      <path
                        fill="currentColor"
                        fill-rule="evenodd"
                        d="M7.5 9.125a1.625 1.625 0 1 0 0-3.25a1.625 1.625 0 0 0 0 3.25Zm0 1a2.625 2.625 0 1 0 0-5.25a2.625 2.625 0 0 0 0 5.25Z"
                        clip-rule="evenodd" />
                    </svg>
                    <svg class="show-if-close" xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 24 24">
                      <g fill="none" fill-rule="evenodd" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round">
                        <path
                          d="M8.5 2.5a3 3 0 0 1 3 3v2a3 3 0 1 1-6 0v-2a3 3 0 0 1 3-3zm7 14v-.728c0-3.187-3.686-5.272-7-5.272s-7 2.085-7 5.272v.728a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1z" />
                        <path
                          fill="currentColor"
                          d="M12.52 2.678A3.001 3.001 0 0 1 14.5 5.5v1c0 1.297-.848 2.581-2 3c.674-.919 1.01-2.086 1.01-3.5s-.331-2.523-.99-3.322zM17.5 17.5h1a1 1 0 0 0 1-1v-.728c0-2.17-1.71-3.83-3.847-4.667c0 0 2.847 2.395 1.847 6.395z" />
                      </g>
                    </svg>
                  </span>
                  <span class="hide-if-close">{{ $t('panel.wizard') }}</span>
                </NuxtLink>
              </li>
              <!-- manage policies verification -->
              <li class="w-full sidebar-nested-item" @click="toggleSidebar('mobile')">
                <NuxtLink
                  :title="$t('panel.manage_policies_verification')"
                  :to="ROUTESNAMES.admin.managePoliciesVerification"
                  class="sidebar-list-item w-full flex items-center gap-2.5 py-3 px-3">
                  <span>
                    <svg class="hide-if-close" xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 15 15">
                      <path
                        fill="currentColor"
                        fill-rule="evenodd"
                        d="M7.5 9.125a1.625 1.625 0 1 0 0-3.25a1.625 1.625 0 0 0 0 3.25Zm0 1a2.625 2.625 0 1 0 0-5.25a2.625 2.625 0 0 0 0 5.25Z"
                        clip-rule="evenodd" />
                    </svg>
                    <svg class="show-if-close" xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 24 24">
                      <g fill="none" fill-rule="evenodd" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round">
                        <path
                          d="M8.5 2.5a3 3 0 0 1 3 3v2a3 3 0 1 1-6 0v-2a3 3 0 0 1 3-3zm7 14v-.728c0-3.187-3.686-5.272-7-5.272s-7 2.085-7 5.272v.728a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1z" />
                        <path
                          fill="currentColor"
                          d="M12.52 2.678A3.001 3.001 0 0 1 14.5 5.5v1c0 1.297-.848 2.581-2 3c.674-.919 1.01-2.086 1.01-3.5s-.331-2.523-.99-3.322zM17.5 17.5h1a1 1 0 0 0 1-1v-.728c0-2.17-1.71-3.83-3.847-4.667c0 0 2.847 2.395 1.847 6.395z" />
                      </g>
                    </svg>
                  </span>
                  <span class="hide-if-close">{{ $t('panel.manage_policies_verification') }}</span>
                </NuxtLink>
              </li>
            </ItemDropdown>
            <!-- Reports -->
            <ItemDropdown :dropDownTitle="$t('panel.reports')" mainRoute="/admin/reports" :currentOpendedDropdown="currentOpendedDropdown" :changeCurrentOpendedDropdown="changeCurrentOpendedDropdown">
              <template v-slot:top-icon>
                <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 48 48"><g fill="none" stroke="currentColor" stroke-linejoin="round" stroke-width="4"><path d="M5 7a3 3 0 0 1 3-3h24a3 3 0 0 1 3 3v37H8a3 3 0 0 1-3-3V7Zm30 17a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v17a3 3 0 0 1-3 3h-5V24Z"/><path stroke-linecap="round" d="M11 12h8m-8 7h12"/></g></svg>
              </template>    
              <!-- products reports -->
              <li class="w-full sidebar-nested-item" @click="toggleSidebar('mobile')">
                <NuxtLink :title="$t('panel.product_reports')" :to="ROUTESNAMES.admin.productsReports" class="sidebar-list-item w-full flex items-center gap-2.5 py-3 px-3">
                  <span>
                    <svg class="hide-if-close" xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 15 15">
                      <path
                        fill="currentColor"
                        fill-rule="evenodd"
                        d="M7.5 9.125a1.625 1.625 0 1 0 0-3.25a1.625 1.625 0 0 0 0 3.25Zm0 1a2.625 2.625 0 1 0 0-5.25a2.625 2.625 0 0 0 0 5.25Z"
                        clip-rule="evenodd" />
                    </svg>
                    <svg class="show-if-close" xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 24 24">
                      <path
                        fill="currentColor"
                        d="M12 23C6.443 21.765 2 16.522 2 11V5l10-4l10 4v6c0 5.524-4.443 10.765-10 12ZM4 6v5a10.58 10.58 0 0 0 8 10a10.58 10.58 0 0 0 8-10V6l-8-3Z" />
                      <circle cx="12" cy="8.5" r="2.5" fill="currentColor" />
                      <path fill="currentColor" d="M7 15a5.782 5.782 0 0 0 5 3a5.782 5.782 0 0 0 5-3c-.025-1.896-3.342-3-5-3c-1.667 0-4.975 1.104-5 3Z" />
                    </svg>
                  </span>
                  <span class="hide-if-close item-title">{{ $t('panel.products') }} </span>
                </NuxtLink>
              </li>
              <!-- stores reports -->
              <li class="w-full sidebar-nested-item" @click="toggleSidebar('mobile')">
                <NuxtLink :title="$t('panel.store_reports')" :to="ROUTESNAMES.admin.storesReports" class="sidebar-list-item w-full flex items-center gap-2.5 py-3 px-3">
                  <span>
                    <svg class="hide-if-close" xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 15 15">
                      <path
                        fill="currentColor"
                        fill-rule="evenodd"
                        d="M7.5 9.125a1.625 1.625 0 1 0 0-3.25a1.625 1.625 0 0 0 0 3.25Zm0 1a2.625 2.625 0 1 0 0-5.25a2.625 2.625 0 0 0 0 5.25Z"
                        clip-rule="evenodd" />
                    </svg>
                    <svg class="show-if-close" xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 24 24">
                      <g fill="none" fill-rule="evenodd" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round">
                        <path
                          d="M8.5 2.5a3 3 0 0 1 3 3v2a3 3 0 1 1-6 0v-2a3 3 0 0 1 3-3zm7 14v-.728c0-3.187-3.686-5.272-7-5.272s-7 2.085-7 5.272v.728a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1z" />
                        <path
                          fill="currentColor"
                          d="M12.52 2.678A3.001 3.001 0 0 1 14.5 5.5v1c0 1.297-.848 2.581-2 3c.674-.919 1.01-2.086 1.01-3.5s-.331-2.523-.99-3.322zM17.5 17.5h1a1 1 0 0 0 1-1v-.728c0-2.17-1.71-3.83-3.847-4.667c0 0 2.847 2.395 1.847 6.395z" />
                      </g>
                    </svg>
                  </span>
                  <span class="hide-if-close item-title"> {{ $t('panel.stores') }}</span>
                </NuxtLink>
              </li>
               <!-- orders reports -->
              <li class="w-full sidebar-nested-item" @click="toggleSidebar('mobile')">
                <NuxtLink
                  :title="$t('panel.order_reports')"
                  :to="ROUTESNAMES.admin.ordersReports"
                  class="sidebar-list-item w-full flex items-center gap-2.5 py-3 px-3">
                  <span>
                    <svg class="hide-if-close" xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 15 15">
                      <path
                        fill="currentColor"
                        fill-rule="evenodd"
                        d="M7.5 9.125a1.625 1.625 0 1 0 0-3.25a1.625 1.625 0 0 0 0 3.25Zm0 1a2.625 2.625 0 1 0 0-5.25a2.625 2.625 0 0 0 0 5.25Z"
                        clip-rule="evenodd" />
                    </svg>
                    <svg class="show-if-close" xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 24 24">
                      <g fill="none" fill-rule="evenodd" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round">
                        <path
                          d="M8.5 2.5a3 3 0 0 1 3 3v2a3 3 0 1 1-6 0v-2a3 3 0 0 1 3-3zm7 14v-.728c0-3.187-3.686-5.272-7-5.272s-7 2.085-7 5.272v.728a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1z" />
                        <path
                          fill="currentColor"
                          d="M12.52 2.678A3.001 3.001 0 0 1 14.5 5.5v1c0 1.297-.848 2.581-2 3c.674-.919 1.01-2.086 1.01-3.5s-.331-2.523-.99-3.322zM17.5 17.5h1a1 1 0 0 0 1-1v-.728c0-2.17-1.71-3.83-3.847-4.667c0 0 2.847 2.395 1.847 6.395z" />
                      </g>
                    </svg>
                  </span>
                  <span class="hide-if-close item-title"> {{ $t('panel.orders') }}</span>
                </NuxtLink>
              </li>
            </ItemDropdown>
            <!-- logs -->
            <li class="w-full" @click="toggleSidebar('mobile')">
              <NuxtLink :title="$t('panel.logs')" :to="ROUTESNAMES.admin.logs" class="sidebar-list-item w-full m-0 flex gap-2.5 py-3 px-3">
                <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 16 16"><path fill="white" d="M3 3a2 2 0 0 1 2-2h3.586a1.5 1.5 0 0 1 1.06.44l2.915 2.914A1.5 1.5 0 0 1 13 5.414V13a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2zm2-1a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V6H9.5A1.5 1.5 0 0 1 8 4.5V2zm4.5 3h2.293L9 2.207V4.5a.5.5 0 0 0 .5.5m-4 3a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1zM5 10.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5m.5 1.5a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1z"/></svg>

                <span class="hide-if-close">{{ $t('panel.logs') }}</span>
              </NuxtLink>
            </li>
            <!-- notification logs -->
            <li class="w-full" @click="toggleSidebar('mobile')">
              <NuxtLink :title="$t('panel.notification_logs')" :to="ROUTESNAMES.admin.notification_logs" class="sidebar-list-item w-full m-0 flex gap-2.5 py-3 px-3">
                <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 24 24"><path fill="currentColor" d="M16 14H8a1 1 0 0 0 0 2h8a1 1 0 0 0 0-2Zm0-4h-6a1 1 0 0 0 0 2h6a1 1 0 0 0 0-2Zm4-6h-3V3a1 1 0 0 0-2 0v1h-2V3a1 1 0 0 0-2 0v1H9V3a1 1 0 0 0-2 0v1H4a1 1 0 0 0-1 1v14a3 3 0 0 0 3 3h12a3 3 0 0 0 3-3V5a1 1 0 0 0-1-1Zm-1 15a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V6h2v1a1 1 0 0 0 2 0V6h2v1a1 1 0 0 0 2 0V6h2v1a1 1 0 0 0 2 0V6h2Z"/></svg>
                <span class="hide-if-close">{{ $t('panel.notification_logs') }}</span>
              </NuxtLink>
            </li>
            <!-- search keywords -->
            <li class="w-full" @click="toggleSidebar('mobile')">
              <NuxtLink :title="$t('panel.manage_search_keywords')" :to="ROUTESNAMES.admin.searchKeywords" class="sidebar-list-item w-full m-0 flex gap-2.5 py-3 px-3">
                <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 24 24">
                  <path
                    fill="currentColor"
                    d="M14.8 8L16 9.2L9.2 16L8 14.8L14.8 8M4 4h16c1.11 0 2 .89 2 2v4a2 2 0 1 0 0 4v4c0 1.11-.89 2-2 2H4a2 2 0 0 1-2-2v-4c1.11 0 2-.89 2-2a2 2 0 0 0-2-2V6a2 2 0 0 1 2-2m0 2v2.54a3.994 3.994 0 0 1 0 6.92V18h16v-2.54a3.994 3.994 0 0 1 0-6.92V6H4m5.5 2c.83 0 1.5.67 1.5 1.5S10.33 11 9.5 11S8 10.33 8 9.5S8.67 8 9.5 8m5 5c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5s-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5Z" />
                </svg>
                <span class="hide-if-close">{{ $t('panel.manage_search_keywords') }}</span>
              </NuxtLink>
            </li>
            <!-- manage ads -->
            <li class="w-full" @click="toggleSidebar('mobile')">
              <NuxtLink
                :title="$t('panel.manage_ads')"
                  :to="ROUTESNAMES.admin.manage_ads"
                  class="sidebar-list-item w-full m-0 flex gap-2.5 py-3 px-3"
                >
                <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 24 24"><path fill="currentColor" d="M16 14H8a1 1 0 0 0 0 2h8a1 1 0 0 0 0-2Zm0-4h-6a1 1 0 0 0 0 2h6a1 1 0 0 0 0-2Zm4-6h-3V3a1 1 0 0 0-2 0v1h-2V3a1 1 0 0 0-2 0v1H9V3a1 1 0 0 0-2 0v1H4a1 1 0 0 0-1 1v14a3 3 0 0 0 3 3h12a3 3 0 0 0 3-3V5a1 1 0 0 0-1-1Zm-1 15a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V6h2v1a1 1 0 0 0 2 0V6h2v1a1 1 0 0 0 2 0V6h2v1a1 1 0 0 0 2 0V6h2Z"/></svg>
                  
                  <span class="hide-if-close">{{ $t('panel.manage_ads') }}</span>
                  <span v-if="adsCount > 0" class="bg-red-500 text-white rounded-full w-5 h-5 flex items-center justify-center text-xs">{{ adsCount }}</span>
                </NuxtLink>
              </li>
              <!-- manage stores verification requests -->
              <li class="w-full" @click="toggleSidebar('mobile')">
                <NuxtLink
                  :title="$t('panel.manage_stores_verification_requests')"
                  :to="ROUTESNAMES.admin.stores_verification_requests"
                  class="sidebar-list-item w-full m-0 flex gap-2.5 py-3 px-3"
                >
                <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 24 24"><path fill="currentColor" d="M16 14H8a1 1 0 0 0 0 2h8a1 1 0 0 0 0-2Zm0-4h-6a1 1 0 0 0 0 2h6a1 1 0 0 0 0-2Zm4-6h-3V3a1 1 0 0 0-2 0v1h-2V3a1 1 0 0 0-2 0v1H9V3a1 1 0 0 0-2 0v1H4a1 1 0 0 0-1 1v14a3 3 0 0 0 3 3h12a3 3 0 0 0 3-3V5a1 1 0 0 0-1-1Zm-1 15a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V6h2v1a1 1 0 0 0 2 0V6h2v1a1 1 0 0 0 2 0V6h2v1a1 1 0 0 0 2 0V6h2Z"/></svg>
                  
                  <span class="hide-if-close">{{ $t('panel.manage_stores_verification_requests') }}</span>
                  <span v-if="verificationsCount > 0" class="bg-red-500 text-white rounded-full w-5 h-5 flex items-center justify-center text-xs">{{ verificationsCount }}</span>
                </NuxtLink>
              </li>
              <li class="w-full" @click="toggleSidebar('mobile')">
              <NuxtLink
                :title="$t('news.manage_news')"
                  :to="ROUTESNAMES.admin.manage_news"
                  class="sidebar-list-item w-full m-0 flex gap-2.5 py-3 px-3"
                >
                <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 24 24">
                  <path fill="currentColor" d="M16 14H8a1 1 0 0 0 0 2h8a1 1 0 0 0 0-2Zm0-4h-6a1 1 0 0 0 0 2h6a1 1 0 0 0 0-2Zm4-6h-3V3a1 1 0 0 0-2 0v1h-2V3a1 1 0 0 0-2 0v1H9V3a1 1 0 0 0-2 0v1H4a1 1 0 0 0-1 1v14a3 3 0 0 0 3 3h12a3 3 0 0 0 3-3V5a1 1 0 0 0-1-1Zm-1 15a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V6h2v1a1 1 0 0 0 2 0V6h2v1a1 1 0 0 0 2 0V6h2v1a1 1 0 0 0 2 0V6h2Z"/>
                </svg>
                  
                  <span class="hide-if-close">{{ $t('news.manage_news') }}</span>
                </NuxtLink>
              </li>

              <!-- manage seo for pages -->
            <li class="w-full" @click="toggleSidebar('mobile')">
              <NuxtLink :title="$t('panel.manage_seo')" :to="ROUTESNAMES.admin.manage_seo" class="sidebar-list-item w-full m-0 flex gap-2.5 py-3 px-3">
                <span class>
                  <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 24 24" aria-label="SEO Management">
                    <path fill="currentColor" d="M9.5 3A6.5 6.5 0 0 1 16 9.5c0 1.61-.59 3.09-1.56 4.23l.27.27h.79l5 5l-1.5 1.5l-5-5v-.79l-.27-.27A6.516 6.516 0 0 1 9.5 16A6.5 6.5 0 0 1 3 9.5A6.5 6.5 0 0 1 9.5 3m0 2C7 5 5 7 5 9.5S7 14 9.5 14S14 12 14 9.5S12 5 9.5 5Z"/>
                  </svg>
                </span>
                <span class="hide-if-close">{{ $t('panel.manage_seo_pages') }}</span>
              </NuxtLink>
            </li>
          </Sidebar>
        </div>
        <!-- End of SIDEBAR -->

        <!-- NAVBAR -->
        <nav class="w-full shrink h-screen overflow-y-auto overflow-x-hidden relative">
          <div @click="toggleSidebar('mobile')" id="page-over" class="hidden md:hidden z-30 fixed w-full h-full bg-[#000000CC]"></div>
          <div class="w-full bg-primaryLighter">
            <div class="px-4 w-full py-3.5 flex items-center justify-between admin__header space-x-4 h-16">
              <!-- Sidebar Toggle Button (Desktop) -->
              <div class="hidden md:block"></div>

              <!-- Sidebar Toggle Button (Mobile) -->
              <div
                @click="toggleSidebar('mobile')"
                id="sidebar-toggle-btn"
                class="md:hidden hover:bg-[#ffffff4d] p-2 bg-fox-800 rounded hover:text-white-100 top-3.5 z-90 cursor-pointer">
                <span>
                  <svg class="w-7 h-7 fill-dark-200" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                    <path d="M4 11h12v2H4zm0-5h16v2H4zm0 12h7.235v-2H4z" />
                  </svg>
                </span>
              </div>

              <!-- User button -->
              <div class="user--info">
                <div @click="() => toggleDropdown()" class="user-area px-2.5 md:px-3 py-2 gap-3 inline-flex items-center bg-[#00000025] rounded">
                  <span class="w-7 h-7 inline-flex justify-center items-center bg-gray-50 rounded">
                    <svg class="w-4 h-4 fill-gray-400" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                      <path
                        d="M7.5 6.5C7.5 8.981 9.519 11 12 11s4.5-2.019 4.5-4.5S14.481 2 12 2 7.5 4.019 7.5 6.5zM20 21h1v-1c0-3.859-3.141-7-7-7h-4c-3.86 0-7 3.141-7 7v1h17z" />
                    </svg>
                  </span>
                  <span
                    v-if="localStorageCopy && localStorageCopy.admin && localStorageCopy.admin.name"
                    class="text-gray-100 text-sm uppercase text-ellipsis font-bold"
                    >{{ localStorageCopy.admin.name }}
                  </span>
                </div>

                <div v-show="isDropdownOpen" id="dropdown" style="z-index: 1000000 !important;" class="z-10 w-[190px] bg-white rounded divide-y divide-gray-100 shadow">
                  <ul class="py-1 text-sm text-gray-700" aria-labelledby="multiLevelDropdownButton">
                    <li>
                      <NuxtLink
                        to="/"
                        class="flex py-2 px-4 hover:bg-gray-100 items-center gap-2 justify-between rtl"
                      >
                        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24"><g fill="none" fill-rule="evenodd"><path d="M24 0v24H0V0h24ZM12.593 23.258l-.011.002l-.071.035l-.02.004l-.014-.004l-.071-.035c-.01-.004-.019-.001-.024.005l-.004.01l-.017.428l.005.02l.01.013l.104.074l.015.004l.012-.004l.104-.074l.012-.016l.004-.017l-.017-.427c-.002-.01-.009-.017-.017-.018Zm.265-.113l-.013.002l-.185.093l-.01.01l-.003.011l.018.43l.005.012l.008.007l.201.093c.012.004.023 0 .029-.008l.004-.014l-.034-.614c-.003-.012-.01-.02-.02-.022Zm-.715.002a.023.023 0 0 0-.027.006l-.006.014l-.034.614c0 .012.007.02.017.024l.015-.002l.201-.093l.01-.008l.004-.011l.017-.43l-.003-.012l-.01-.01l-.184-.092Z"/><path fill="currentColor" d="M8.293 12.707a1 1 0 0 1 0-1.414l5.657-5.657a1 1 0 1 1 1.414 1.414L10.414 12l4.95 4.95a1 1 0 0 1-1.414 1.414l-5.657-5.657Z"/></g></svg>
                        <span>{{ $t("general.go_to_website") }}</span>
                      </NuxtLink>
                    </li>
                    <li @click="() => isDropdownOpen = false">
                      <NuxtLink
                        :to="ROUTESNAMES.admin.mySettings"
                        class="flex py-2 px-4 hover:bg-gray-100 items-center gap-2 justify-between rtl"
                      >
                      <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24"><path fill="currentColor" d="M12 8a4 4 0 0 1 4 4a4 4 0 0 1-4 4a4 4 0 0 1-4-4a4 4 0 0 1 4-4m0 2a2 2 0 0 0-2 2a2 2 0 0 0 2 2a2 2 0 0 0 2-2a2 2 0 0 0-2-2m-2 12c-.25 0-.46-.18-.5-.42l-.37-2.65c-.63-.25-1.17-.59-1.69-.99l-2.49 1.01c-.22.08-.49 0-.61-.22l-2-3.46a.493.493 0 0 1 .12-.64l2.11-1.66L4.5 12l.07-1l-2.11-1.63a.493.493 0 0 1-.12-.64l2-3.46c.12-.22.39-.31.61-.22l2.49 1c.52-.39 1.06-.73 1.69-.98l.37-2.65c.04-.24.25-.42.5-.42h4c.25 0 .46.18.5.42l.37 2.65c.63.25 1.17.59 1.69.98l2.49-1c.22-.09.49 0 .61.22l2 3.46c.13.22.07.49-.12.64L19.43 11l.07 1l-.07 1l2.11 1.63c.19.15.25.42.12.64l-2 3.46c-.12.22-.39.31-.61.22l-2.49-1c-.52.39-1.06.73-1.69.98l-.37 2.65c-.04.24-.25.42-.5.42zm1.25-18l-.37 2.61c-1.2.25-2.26.89-3.03 1.78L5.44 7.35l-.75 1.3L6.8 10.2a5.55 5.55 0 0 0 0 3.6l-2.12 1.56l.75 1.3l2.43-1.04c.77.88 1.82 1.52 3.01 1.76l.37 2.62h1.52l.37-2.61c1.19-.25 2.24-.89 3.01-1.77l2.43 1.04l.75-1.3l-2.12-1.55c.4-1.17.4-2.44 0-3.61l2.11-1.55l-.75-1.3l-2.41 1.04a5.42 5.42 0 0 0-3.03-1.77L12.75 4z"/></svg>
                        <span>{{ $t("panel.update_profile") }}</span>
                      </NuxtLink>
                    </li>
                    <!-- <li @click="() => toggleLanguage()">
                      <a
                        href="#"
                        class="flex py-2 px-4 hover:bg-gray-100 items-center gap-2 justify-between rtl"
                      >
                      
                      <svg v-if="isRTL" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"><path fill="currentColor" d="M14 10h2v.757a4.5 4.5 0 0 1 7 3.743V20h-2v-5.5c0-1.43-1.174-2.5-2.5-2.5S16 13.07 16 14.5V20h-2V10Zm-2-6v2H4v5h8v2H4v5h8v2H2V4h10Z"/></svg>

                      <svg v-else xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"><path fill="currentColor" d="M12 4c-1.92 0-3.5 1.58-3.5 3.5c0 .93.38 1.78 1 2.41c-1.53 1-2.5 2.71-2.5 4.59c0 3.03 2.47 5.5 5.5 5.5c1.76 0 3.5-.46 5-1.34l-1-1.73c-1.22.7-2.6 1.07-4 1.07c-1.94 0-3.5-1.55-3.5-3.5a3.49 3.49 0 0 1 2.59-3.38l5.21-1.4l-.52-1.93L11.83 9c-.75-.1-1.33-.72-1.33-1.5c0-.84.66-1.5 1.5-1.5c.26 0 .5.07.75.2l1-1.73C13.22 4.16 12.61 4 12 4Z"/></svg>

                        <span>{{ $t("general.toggle_lang") }}</span>
                      </a>
                    </li> -->
                    <li @click="() => openProfileDialog()">
                      <a href="#" class="flex py-2 px-4 hover:bg-gray-100 items-center gap-2 justify-between rtl">
                        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24">
                          <g fill="none" stroke="currentColor" stroke-linecap="round" stroke-width="1.5">
                            <path d="M12 20a8 8 0 1 1 0-16" opacity=".5" />
                            <path stroke-linejoin="round" d="M10 12h10m0 0l-3-3m3 3l-3 3" />
                          </g>
                        </svg>
                        <span>{{ $t('general.logout') }}</span>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div class="panel-content bg-light-1 relative">
            <slot />
          </div>
          <!-- panel footer -->
          <Footer />
        </nav>
        <!-- black transparent backdrop -->
        <div class="dropdown--backdrop" @click="() => (isDropdownOpen = false)" v-show="isDropdownOpen"></div>
      </div>
    </div>
  </div>
</template>

<script>
import 'vue3-easy-data-table/dist/style.css';
import Sidebar from '@/components/panel/layout/Sidebar/PanelSidebar.vue';
import ItemDropdown from '@/components/panel/layout/Sidebar/ItemDropdown.vue';
import { useGlobalStore } from '@/store/Modules/global.js';
import { MAINROLES, ROUTESNAMES, APIREQUESTS, lowerString } from '@/helpers';
import { mapState } from 'pinia';
import Footer from '@/components/panel/layout/Footer.vue';


export default {
  name: "admin-layout",
  data() {
    return {
      isDropdownOpen: false,
      isLogoutDialogOpen: false,
      isSidebarOpen: false,
      isLoggingout: false,
      currentOpendedDropdown: "",
      unarchivedRequestsCount: 0,
      withdrawalRequestsCount: 0,
      verificationsCount: 0,
      adsCount: 0,
      complaintsCount: 0,
      warningsCount: 0,
    };
  },
  components: {
    Sidebar,
    ItemDropdown,
    Footer
  },
  computed: {
    ...mapState(useGlobalStore, {
      global: (store) => store,
      localStorageCopy: (store) => store?.localStorageCopy,
    }),
  },
  methods: {
    getUnarchivedRequestsCount() {
      this.makeRequest({
        specificRole: MAINROLES.admin,
        owner: MAINROLES.admin,
        method: APIREQUESTS.panel.getUnarchivedRequestsCount.method,
        url: APIREQUESTS.panel.getUnarchivedRequestsCount.url,
      }).then(res => {
        this.unarchivedRequestsCount = res.data.count;
      }).catch(err => {
        console.log(err);
      });
    },
    getWithdrawalRequestsCount() {
      this.makeRequest({
        specificRole: MAINROLES.admin,
        owner: MAINROLES.admin,
        method: APIREQUESTS.panel.getWithdrawalRequestsCount.method,
        url: APIREQUESTS.panel.getWithdrawalRequestsCount.url,
      }).then(res => {
        this.withdrawalRequestsCount = res.data.count;
      }).catch(err => {
        console.log(err);
      });
    },
    getVerificationsCount() {
      this.makeRequest({
        specificRole: MAINROLES.admin,
        owner: MAINROLES.admin,
        method: APIREQUESTS.panel.getVerificationsCount.method,
        url: APIREQUESTS.panel.getVerificationsCount.url,
      }).then(res => {
        this.verificationsCount = res.data.count;
      }).catch(err => {
        console.log(err);
      });
    },
    getAdsCount() {
      this.makeRequest({
        specificRole: MAINROLES.admin,
        owner: MAINROLES.admin,
        method: APIREQUESTS.panel.getAdsCount.method,
        url: APIREQUESTS.panel.getAdsCount.url,
      }).then(res => {
        this.adsCount = res.data.count;
      }).catch(err => {
        console.log(err);
      });
    },
    getComplaintsCount() {
      this.makeRequest({
        specificRole: MAINROLES.admin,
        owner: MAINROLES.admin,
        method: APIREQUESTS.admin.getCountComplaints.method,
        url: APIREQUESTS.admin.getCountComplaints.url,
      }).then(res => {
        if (res?.data) {
          this.complaintsCount = res.data.total_count || 0;
        }
      }).catch(err => {
        console.log(err);
      });
    },
    getWarningsCount() {
      this.makeRequest({
        specificRole: MAINROLES.admin,
        owner: MAINROLES.admin,
        method: APIREQUESTS.admin.countWarnings.method,
        url: APIREQUESTS.admin.countWarnings.url,
      }).then(res => {
        if (res?.data) {
          this.warningsCount = res.data.count || 0;
        }
      }).catch(err => {
        console.log(err);
      });
    },
    openProfileDialog() {
      this.isDropdownOpen = false;
      this.isLogoutDialogOpen = true;
    },
    toggleDropdown() {
      this.isDropdownOpen = !this.isDropdownOpen;
    },
    closeSidebarMobile() {
      const sibebarEl = document.getElementById('sidebar-menu');

      if (sibebarEl.classList.contains('right-0')) {
        sibebarEl.classList.remove('right-0');
        sibebarEl.classList.add('-right-[300px]');
      }
    },
    changeCurrentOpendedDropdown(newVal){
      this.currentOpendedDropdown = newVal;
    },
    toggleLanguage() {
      const reversedLang = this.useLocalStorage({ type: 'get', key: 'language' }) === 'ar' ? 'en' : 'ar';
      if (reversedLang) {
        this.useLocalStorage({
          type: 'set',
          key: 'language',
          value: lowerString(reversedLang),
        });
        this.isDropdownOpen = false;
      }
    },
    logoutUser() {
      this.isLoggingout = true;
      const cookieUID = useCookie('UID', {
        secure: true,
      })?.value;

      const bodyRequest = {
        uid: cookieUID,
      }
      this.makeRequest({
        specificRole: MAINROLES.admin,
        owner: MAINROLES.admin,
        method: APIREQUESTS.panel.logout.method,
        url: APIREQUESTS.panel.logout.url,
        formData: JSON.stringify(bodyRequest),
      })
        .then((res) => {
          this.isLoggingout = false;
          // failed
          if (!res?.status) {
            this.notify({
              type: 'error',
              msg: res.message,
            });
          } else {
            // succeeded

            this.useLocalStorage({
              type: 'set',
              value: {},
              key: MAINROLES.admin || '',
            });
            // this.useLocalStorage({ type: 'set', key: 'paramOptions', value: {} });

            this.$nextTick(() => {
              this.$router.replace({ path: ROUTESNAMES.panel.login });
            });
          }
        })
        .catch((err) => {
          this.isLoggingout = false;
          this.notify({
            type: 'error',
            msg: err?.data?.message || 'فشل في اتمام الطلب. من فضلك عاود المحاولة في وقت لاحق.',
          });
        });
    },
    toggleSidebar(device) {
      const sibebarEl = document.getElementById('sidebar-menu');

      if (device == 'mobile') {
        // if (sibebarEl.classList.contains(`-${this.isRTL ? 'right': 'left'}-[300px]`)) {
        //   sibebarEl.classList.remove(`-${this.isRTL ? 'right': 'left'}-[300px]`);
        //   sibebarEl.classList.add(`${this.isRTL ? 'right': 'left'}-0`);
        //   document.getElementById("page-over").classList.remove(`hidden`);
        // } else if (sibebarEl.classList.contains(`${this.isRTL ? 'right': 'left'}-0`)) {
        //   sibebarEl.classList.remove(`${this.isRTL ? 'right': 'left'}-0`);
        //   sibebarEl.classList.add(`-${this.isRTL ? 'right': 'left'}-[300px]`);
        //   document.getElementById("page-over").classList.add("hidden");
        // }
        if (sibebarEl.classList.contains('-right-[300px]')) {
          sibebarEl.classList.remove('-right-[300px]');
          sibebarEl.classList.add('right-0');
          document.getElementById('page-over').classList.remove('hidden');
        } else if (sibebarEl.classList.contains('right-0')) {
          sibebarEl.classList.remove('right-0');
          sibebarEl.classList.add('-right-[300px]');
          document.getElementById('page-over').classList.add('hidden');
        }
      } else {
        this.isSidebarOpen = !this.isSidebarOpen;
        if (sibebarEl.classList.contains('sidebar-opened')) {
          sibebarEl.classList.remove('sidebar-opened');
          sibebarEl.classList.add('sidebar-close');
        } else if (sibebarEl.classList.contains('sidebar-close')) {
          sibebarEl.classList.remove('sidebar-close');
          sibebarEl.classList.add('sidebar-opened');
        }
      }
    },
  },
  mounted() {
    this.getUnarchivedRequestsCount();
    this.getWithdrawalRequestsCount();
    this.getVerificationsCount();
    this.getAdsCount();
    this.getComplaintsCount();
    this.getWarningsCount();
  },
};
</script>
